import React from 'react';
import { cn } from '@/lib/utils';
import { X } from 'lucide-react';
import { DialogTitle } from '@/components/ui/SossietyDialog';

interface SossietyDialogHeaderProps {
  title: string;
  children?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  description?: React.ReactNode;
}

interface SossietyDialogIconProps {
  onClick?: () => void;
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

interface SossietyDialogCloseProps {
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}

export const SossietyDialogClose: React.FC<SossietyDialogCloseProps> = ({
  onClick,
  className,
  disabled = false
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none disabled:pointer-events-none border-0 focus:ring-0 focus:border-0",
        className
      )}
    >
      <X className="h-6 w-6" />
      <span className="sr-only">Close</span>
    </button>
  );
};

export const SossietyDialogIcon: React.FC<SossietyDialogIconProps> = ({
  onClick,
  children,
  className,
  disabled = false
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none disabled:pointer-events-none border-0 focus:ring-0 focus:border-0",
        className
      )}
    >
      {children}
    </button>
  );
};

export const SossietyDialogHeader: React.FC<SossietyDialogHeaderProps> = ({
  title,
  children,
  className,
  titleClassName,
  description
}) => {
  return (
    <div className={cn("relative mb-4 !space-y-0", className)}>
      {/* Title - aligned with close button */}
      <DialogTitle className={cn(
        "text-xl font-semibold text-black text-center leading-none tracking-normal pr-20 pt-4 flex-1 ml-12",
        titleClassName
      )}>
        {title}
      </DialogTitle>
      
      {/* Icons container - aligned with title */}
      <div className="absolute top-4 right-2 flex items-center gap-0.5">
        {children}
      </div>
      
      {/* Description - if provided */}
      {description && (
        <div className="mt-2">
          {description}
        </div>
      )}
    </div>
  );
}; 